import React from 'react';
import { Monitor, Video, Users, ArrowRight, Clock, Car, PlayCircle, Award, MessageCircle, Calendar, Handshake, MapPin, FileCheck, UserPlus } from 'lucide-react';
import { Card } from './ui/Card';
const onlineBenefits = [{
  icon: Clock,
  text: '24/7 Online Access'
}, {
  icon: Car,
  text: 'No Driving Required'
}, {
  icon: PlayCircle,
  text: 'Start & Stop Anytime'
}, {
  icon: Award,
  text: 'Instant Certificates upon class completion'
}];
const zoomBenefits = [{
  icon: MessageCircle,
  text: 'Live Q&A with Instructors'
}, {
  icon: Users,
  text: 'Interactive Group Learning'
}, {
  icon: Calendar,
  text: 'Scheduled Class Times'
}, {
  icon: Car,
  text: 'Join from Anywhere'
}];
const liveBenefits = [{
  icon: FileCheck,
  text: 'Leave With Your Certificate In Hand'
}, {
  icon: UserPlus,
  text: 'Meet Various Affiliate Partners'
}, {
  icon: MessageCircle,
  text: 'Direct Instructor Access'
}, {
  icon: MapPin,
  text: 'Local Arizona Locations'
}];
const formats = [{
  title: 'On-Demand Classes',
  description: 'Self-paced courses you can take anytime, anywhere. Perfect for busy schedules.',
  icon: Monitor,
  color: 'text-blue-600',
  bgColor: 'bg-blue-50',
  cta: 'Browse On-Demand Classes',
  benefits: onlineBenefits
}, {
  title: 'Zoom Classes',
  description: 'Live interactive instruction from the comfort of your home or office. Real-time engagement with instructors.',
  icon: Video,
  color: 'text-brand-purple-600',
  bgColor: 'bg-brand-purple-50',
  cta: 'View Zoom Schedule',
  benefits: zoomBenefits
}, {
  title: 'In-Person Classes',
  description: 'Traditional classroom setting for hands-on learning and networking with other agents.',
  icon: Users,
  color: 'text-brand-orange-600',
  bgColor: 'bg-brand-orange-50',
  cta: 'Find a Location',
  benefits: liveBenefits
}];
export function ClassFormats() {
  return <section className="py-20 bg-gray-50" data-id="element-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="text-center mb-12" data-id="element-42">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4" data-id="element-43">
            Choose Your Learning Style
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-44">
            We offer flexible formats to meet your Arizona real estate license
            renewal requirements.
          </p>

          <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-md p-6 border-2 border-brand-purple-200" data-id="element-45">
            <p className="text-gray-700 leading-relaxed font-medium" data-id="element-46">
              <span className="text-brand-purple-700" data-id="element-47">"</span>Our mission is to
              provide high-quality, relevant education that makes the renewal
              process as simple as possible for Arizona real estate
              professionals.<span className="text-brand-purple-700" data-id="element-48">"</span>
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-49">
          {formats.map((format, index) => <Card key={index} hoverEffect className="flex flex-col h-full p-8 border-2 border-gray-200 hover:border-gray-300" data-id="element-50">
              <div className={`w-14 h-14 rounded-xl ${format.bgColor} ${format.color} flex items-center justify-center mb-6`} data-id="element-51">
                <format.icon className="w-7 h-7" data-id="element-52" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-53">
                {format.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-54">
                {format.description}
              </p>

              {format.benefits && <ul className="space-y-3 mb-6 flex-grow" data-id="element-55">
                  {format.benefits.map((benefit, idx) => <li key={idx} className="flex items-center text-sm text-gray-700" data-id="element-56">
                      <div className={`w-8 h-8 rounded-full ${format.bgColor} ${format.color} flex items-center justify-center mr-3 flex-shrink-0`} data-id="element-57">
                        <benefit.icon className="w-4 h-4" data-id="element-58" />
                      </div>
                      <span className="font-medium" data-id="element-59">{benefit.text}</span>
                    </li>)}
                </ul>}

              <div className="mt-auto" data-id="element-60">
                <a href="#" className={`inline-flex items-center font-semibold ${format.color} hover:underline`} data-id="element-61">
                  {format.cta} <ArrowRight className="ml-2 w-4 h-4" data-id="element-62" />
                </a>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}